export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88')
];

export const server_loads = [12];

export const dictionary = {
		"/": [14],
		"/apps/mars": [15],
		"/apps/rars": [16],
		"/blog": [~17,[2]],
		"/blog/posts/[slug]": [~18,[2]],
		"/blog/tags/[tag]": [~19,[2]],
		"/changelog": [20],
		"/chat": [21],
		"/documentation": [22,[3]],
		"/documentation/m68k": [23,[3,4]],
		"/documentation/m68k/addressing-mode": [24,[3,4]],
		"/documentation/m68k/all": [25,[3,4]],
		"/documentation/m68k/assembler-features": [26,[3,4]],
		"/documentation/m68k/condition-codes": [27,[3,4]],
		"/documentation/m68k/directive": [28,[3,4]],
		"/documentation/m68k/exceptions": [29,[3,4]],
		"/documentation/m68k/instruction": [30,[3,4]],
		"/documentation/m68k/instruction/[instructionName]": [~31,[3,4]],
		"/documentation/m68k/shift-direction": [32,[3,4]],
		"/documentation/m68k/synth": [33,[3,4]],
		"/documentation/m68k/traps": [34,[3,4]],
		"/documentation/mips": [35,[3,5]],
		"/documentation/mips/all": [36,[3,5]],
		"/documentation/mips/directive": [37,[3,5]],
		"/documentation/mips/instruction": [38,[3,5]],
		"/documentation/mips/instruction/[instructionName]": [~39,[3,5]],
		"/documentation/mips/registers": [40,[3,5]],
		"/documentation/mips/runtime-library": [41,[3,5]],
		"/documentation/mips/screen": [42,[3,5]],
		"/documentation/mips/synth": [43,[3,5]],
		"/documentation/mips/syscall": [44,[3,5]],
		"/documentation/mips/using-c": [45,[3,5]],
		"/documentation/risc-v": [46,[3,6]],
		"/documentation/risc-v/all": [47,[3,6]],
		"/documentation/risc-v/directive": [48,[3,6]],
		"/documentation/risc-v/instruction": [49,[3,6]],
		"/documentation/risc-v/instruction/[instructionName]": [~50,[3,6]],
		"/documentation/risc-v/registers": [51,[3,6]],
		"/documentation/risc-v/runtime-library": [52,[3,6]],
		"/documentation/risc-v/screen": [53,[3,6]],
		"/documentation/risc-v/synth": [54,[3,6]],
		"/documentation/risc-v/syscall": [55,[3,6]],
		"/documentation/risc-v/using-c": [56,[3,6]],
		"/documentation/x86": [57,[3,7]],
		"/documentation/x86/all": [58,[3,7]],
		"/documentation/x86/directive": [59,[3,7]],
		"/documentation/x86/executables": [60,[3,7]],
		"/documentation/x86/extensions": [61,[3,7]],
		"/documentation/x86/input": [62,[3,7]],
		"/documentation/x86/instruction": [63,[3,7]],
		"/documentation/x86/instruction/[instructionName]": [~64,[3,7]],
		"/documentation/x86/registers": [65,[3,7]],
		"/documentation/x86/runtime-library": [66,[3,7]],
		"/documentation/x86/screen": [67,[3,7]],
		"/documentation/x86/sound": [68,[3,7]],
		"/documentation/x86/syscall": [69,[3,7]],
		"/documentation/x86/using-c": [70,[3,7]],
		"/documentation/x86/vector-instructions": [71,[3,7]],
		"/documentation/z80": [72,[3,8]],
		"/documentation/z80/all": [73,[3,8]],
		"/documentation/z80/directive": [74,[3,8]],
		"/documentation/z80/instruction": [75,[3,8]],
		"/documentation/z80/instruction/[instructionName]": [~76,[3,8]],
		"/documentation/z80/io": [77,[3,8]],
		"/documentation/z80/registers": [78,[3,8]],
		"/donate": [79],
		"/embed": [80,[9]],
		"/exam": [81,[10]],
		"/exam/session": [82,[10]],
		"/learn/courses": [~83,[11]],
		"/learn/courses/[courseId]": [~84,[11,12]],
		"/learn/courses/[courseId]/[moduleId]/[lectureId]": [~85,[11,12]],
		"/projects": [86],
		"/projects/create": [~88],
		"/projects/[project]": [87,[13]]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);